import styles from './appListDropDown.module.css';
import AppIcon from 'assets/AppIcon.svg';

export default function AppListDropDown() {
    return <img style={{ width: '32px', height: '32px', padding: 0 }} className={styles.desktopImage} alt="AppIcon" src={AppIcon} />;
}
